import { ChangeDetectorRef, Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DataService } from '../dataservice.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MediaMatcher } from '@angular/cdk/layout';

@Directive({
  selector: '[appCustomV2DesignLayout]'
})
export class CustomV2DesignLayoutDirective implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  private smallDevice: MediaQueryList;
  private mobileQueryListener: () => void;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private changeDetectorRef: ChangeDetectorRef,
    private dataService: DataService,
    private mediaMatcher: MediaMatcher
  ) {
    this.smallDevice = mediaMatcher.matchMedia('(max-width: 991.98px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    if (localStorage.getItem('designVersion') === 'V2') {
      this.renderer.addClass(this.el.nativeElement, 'new-app-container-theme');

      const snavMenu = this.el.nativeElement.querySelector('.app-side');
      this.renderer.addClass(snavMenu, 'new-app-side-theme');
      this.renderer.setStyle(snavMenu, 'padding', '0');
      
      const generalContent = this.el.nativeElement.querySelector('.app-main');
      this.renderer.addClass(generalContent, 'new-app-main-theme');
      this.renderer.addClass(generalContent, '--bg-white');

      this.listenMenuStatus(snavMenu, generalContent);
      this.listenScreenSize();
    }
  }

  listenScreenSize() {
    
    this.smallDevice.addEventListener('change', () => {
      
      const generalContent = this.el.nativeElement.querySelector('.app-main');
      const snavMenu = this.el.nativeElement.querySelector('.app-side');
      const menuStatus = JSON.parse(localStorage.getItem('statusMenu'));

      if (this.smallDevice.matches) {
        const snavMenuMarginLeft = menuStatus ? '-280px' : '0px';
        this.renderer.setStyle(generalContent, 'margin-left', '0px');
        this.renderer.setStyle(snavMenu, 'left', snavMenuMarginLeft);
      } else {
        const snavMenuWidth = menuStatus ? 'var(--width-collapsed-side-navigation-menu)' : 'var(--width-expanded-side-navigation-menu)';
        this.renderer.setStyle(generalContent, 'margin-left', snavMenuWidth);
        this.renderer.setStyle(snavMenu, 'left', '0px');
      }

    });
  }

  listenMenuStatus(snavMenu: ElementRef, generalContent: ElementRef) {
    this.dataService.collapsedMenuSubject$
    .pipe(
      takeUntil(this.destroy$)
    ).subscribe(val => {
      const snavMenuWidth = val ? 'var(--width-collapsed-side-navigation-menu)' : 'var(--width-expanded-side-navigation-menu)';
      this.renderer.setStyle(snavMenu, 'width', snavMenuWidth);

      if (this.smallDevice.matches) {
        const snavMenuMarginLeft = val ? '-280px' : '0px';
        this.renderer.setStyle(snavMenu, 'left', snavMenuMarginLeft);
        this.renderer.setStyle(generalContent, 'margin-left', '0px');
      } else {
        this.renderer.setStyle(generalContent, 'margin-left', snavMenuWidth);
      }
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
